import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button, Modal, Mo, Flex, Input } from 'nallian-shared-ui/lib/components';

const TypeToConfirmModal = ({ onConfirm, onCancel, header, loading, value }) => {
  const { t } = useTranslation();
  const [confirmText, setConfirmText] = useState('');

  const handleChangeConfirmText = useCallback((_, target) => setConfirmText(target.value), [
    setConfirmText,
  ]);

  useEffect(() => {
    return () => {
      setConfirmText('');
    };
  }, [setConfirmText]);

  return (
    <Modal open basic size="tiny">
      <Mo.Header>{header}</Mo.Header>
      <Mo.Content>
        <Flex margin="0 0 1rem">{t('pleaseTypeToEnableConfirmButton', { message: value })}</Flex>
        <Input fluid placeholder={t('pleaseTypeHere')} onChange={handleChangeConfirmText} />
      </Mo.Content>
      <Mo.Actions>
        <Button inverted content={t('cancel')} onClick={onCancel} disabled={loading} />
        <Button
          primary
          inverted
          content={t('confirm')}
          onClick={onConfirm}
          loading={loading}
          disabled={loading || confirmText !== value}
        />
      </Mo.Actions>
    </Modal>
  );
};

TypeToConfirmModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  value: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

TypeToConfirmModal.defaultProps = { loading: false };

export default TypeToConfirmModal;
